import { createSlice } from '@reduxjs/toolkit'
import { contentTexts } from 'locale/es'
import ContentService from 'services/ContentService'
import { toast } from './notificationReducer'

const initialState = { data: [], loading: false, error: null }

const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setContent(state, action) {
      const { data } = action.payload

      return { ...state, data, loading: false, error: null }
    },
    appendContent(state, action) {
      const { data } = action.payload

      return { ...state, data: [...state.data, data], loading: false, error: null }
    },
    updateContent(state, action) {
      const { data } = action.payload

      const updatedContent = state.data.map((content) =>
        content.id !== data.id ? content : data
      )

      return { ...state, data: updatedContent, loading: false, error: null }
    },
    deleteContent(state, action) {
      const newDataState = state.data.filter((content) => content.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null, }
    },
    setContentLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setContentError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetContentState(state, action) {
      return initialState
    }
  },
})

export const { setContent, appendContent, updateContent, deleteContent, appendComment, setContentLoading, setContentError, resetContentState } =
  contentSlice.actions

export const initializeCenterContent = (centerId) => {
  return async (dispatch) => {
    try {
      dispatch(setContentLoading());

      const { data } = await ContentService.getAll(centerId)
      dispatch(setContent({ data }))
    }
    catch (error) {
      console.error(error)
      dispatch(setContentError({ message: error.message, status: error.response?.status }));
      dispatch(toast(contentTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const createContent = (contentObj) => {
  return async (dispatch) => {
    try {
      const { data } = await ContentService.create(contentObj)
      dispatch(appendContent({ data }))
      dispatch(toast(contentTexts.CREATED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setContentError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const updateContentAction = (fieldsToUpdate) => {
  return async (dispatch) => {
    try {
      const { data } = await ContentService.update(fieldsToUpdate.id, fieldsToUpdate)
      dispatch(updateContent({ data }))
      dispatch(toast(contentTexts.EDITED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setContentError({ message: error.message, status: error.response?.status }));
      throw error
    }
  }
}

export const deleteContentAction = (id) => {
  return async (dispatch) => {
    try {
      await ContentService.remove(id)
      dispatch(deleteContent(id))
      dispatch(toast(contentTexts.DELETED, "success"))
    } catch (error) {
      console.error(error)
      dispatch(setContentError({ message: error.message, status: error.response?.status }));
      dispatch(toast(contentTexts.DELETED_ERROR, "error"))
    }
  }
}

export default contentSlice.reducer